import {
  BaseExportModal,
  ExportModalProps,
} from 'components/Modals/ExportModal/ExportModal'
import { createExportColumnHelper } from 'components/DataExpansionComponents/Common/commonColumnHelpers'
import { UNMATCHED_DOORS_COLUMNS } from './UnmatchedDoorsColumnsInfo'
import { COMMON_COLUMNS } from '../Common/CommonColumnsInfo'
import { useDownload } from 'features/download-widget'
import {
  getDownloadStatus,
  startDoorProxiesExportV2,
} from 'services/downloadsApi'
import { useColumnStoreContext } from 'stores/ColumnsStore/useColumnsStoreContext'

interface UnmatchedExportModalProps extends ExportModalProps {
  subCategoryId: number
}

export function UnmatchedExportModal(props: UnmatchedExportModalProps) {
  const unmatchedColumnHelper = createExportColumnHelper({
    columns: { ...UNMATCHED_DOORS_COLUMNS, ...COMMON_COLUMNS },
  })

  const selectedColumns = useColumnStoreContext(
    (state) => state.selectedColumns
  )
  const { startDownload } = useDownload()

  const columns = [
    {
      title: 'Door Attributes',
      elements: [
        unmatchedColumnHelper.retrieveColumn('name'),
        unmatchedColumnHelper.retrieveColumn('domain'),
        unmatchedColumnHelper.retrieveColumn('address'),
        unmatchedColumnHelper.retrieveColumn('city'),
        unmatchedColumnHelper.retrieveColumn('state'),
        unmatchedColumnHelper.retrieveColumn('zipcode'),
        unmatchedColumnHelper.retrieveColumn('country'),
        unmatchedColumnHelper.retrieveColumn('phone_number'),
        unmatchedColumnHelper.retrieveColumn('extension'),
        ['created', 'Created Date'],
      ],
    },
    {
      title: 'Chain Attributes',
      elements: [
        ['chain_proxy.name', 'Parent Company'],
        ['chain_proxy.taglist', 'Chain Tags'],
        ['chain_proxy.distributors', 'Chain Distributors'],
        ['chain_proxy.gpos', 'Chain GPOs'],
        unmatchedColumnHelper.retrieveColumn('chain_size'),
      ],
    },
    {
      title: 'Account Details',
      elements: [
        ['chain_proxy.campaigns', 'Campaigns'],
        // TODO: Uncomment this when we have a better way to handle deal counts
        // unmatchedColumnHelper.retrieveColumn('deal_count'),
        ['deals.sales_stages', 'Sales Stages'],
        ['deals.account_owners', 'Account Owners'],
        ['taglist', 'Door Tags'],
        ['distributors', 'Door Distributors'],
        ['gpos', 'Door GPOs'],
        unmatchedColumnHelper.retrieveColumn('note_count'),
      ],
    },
  ]

  const onSubmit = async (
    selectedCols: string[],
    exportType: 'csv' | 'xlsx'
  ) => {
    await startDownload({
      items: [{ id: 0, name: 'Exporting Unmatched Doors...' }],
      initiate: async () => {
        const { sort, ...filterWithoutSort } = (props.filters ?? {}) as Record<
          string,
          unknown
        >
        const response = await startDoorProxiesExportV2({
          selected_columns: selectedCols,
          export_type: exportType,
          filter_params: {
            ...filterWithoutSort,
            sub_category_id: props.subCategoryId,
            include_ids: props.selectedIds ?? [],
            exclude_ids: props.excludeIds ?? [],
          },
          sort: sort as string | undefined,
        })
        return { type: 'async', requestId: response.request_id }
      },
      getStatus: getDownloadStatus,
      label: 'Unmatched Companies',
    })
  }

  return (
    <BaseExportModal
      title="Select Columns for Unmatched Doors Download"
      subTitle="Download up to 10,000 Unmatched Doors at a time, with any of the following columns. Any filters already applied will remain active."
      submitText="Export Unmatched Doors"
      columns={columns}
      selectedColumns={selectedColumns}
      onSubmit={onSubmit}
      show={props.show}
      handleClose={props._handleClose}
    />
  )
}
